import { CallState, LoadingState } from '@lcs/shared/api';
import { createReducer, on } from '@ngrx/store';
import { onReset } from 'src/app/authentication/reset-reducer';
import { DeviceDetailView } from '../models/device-detail-view.model';
import * as DeviceDetailActions from './device-detail.actions';

export const deviceDetailFeatureKey = 'deviceDetail';

export interface State {
   device: DeviceDetailView | null;
   callState: CallState;
}

export const initialState: State = {
   callState: LoadingState.Init,
   device: null,
};

export const reducer = createReducer(
   initialState,
   onReset(initialState),
   on(DeviceDetailActions.deviceDetailLoad, DeviceDetailActions.deviceDetailCancel, (state) => {
      return {
         ...state,
         callState: LoadingState.Loading,
         device: null,
      };
   }),
   on(
      DeviceDetailActions.loadDeviceDetailSuccess,
      DeviceDetailActions.loadSystemDeviceDetailsSuccess,
      (state, action) => {
         const device: DeviceDetailView = action.data;
         return {
            ...state,
            callState: LoadingState.Loaded,
            device: {
               ...device,
            },
         };
      }
   ),
   on(DeviceDetailActions.loadDeviceDetailFailure, (state, action) => {
      return {
         ...state,
         callState: action,
      };
   }),
   on(DeviceDetailActions.saveDeviceDetail, (state) => {
      return {
         ...state,
         callState: LoadingState.Loading,
      };
   }),
   on(
      DeviceDetailActions.saveDeviceDetailFailure,
      DeviceDetailActions.loadDeviceAccessDenied,
      DeviceDetailActions.releaseDeviceDetailSuccess,
      DeviceDetailActions.releaseDeviceToAccountSuccess,
      (state) => {
         return {
            ...state,
            callState: LoadingState.Loaded,
         };
      }
   ),
   on(DeviceDetailActions.confirmDeviceChange, (state) => {
      return {
         ...state,
         callState: LoadingState.Loading,
      };
   })
);
